export default __webpack_public_path__ + "static/media/seo-consulting.b6aa7f2d.svg";